import React from "react";

export const BannerIcon = ({nameOfClass}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={nameOfClass} viewBox="0 0 24 24" fill="currentColor">
            <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 10h5v1H5v-1zm0-2h8v1H5V8zm0 4h6v1H5v-1zm9-6h5v4h-5V6z"/>
        </svg>
    );
};